export const sectionVariable = {}
